import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HttpCacheService extends Map<string, HttpResponse<any>> {
    constructor() {
        super();
    }
}
